export default __webpack_public_path__ + "static/media/linkedin-logo.3939cc7b.svg";